import { ParamListBase, StackNavigationState, TypedNavigator } from '@react-navigation/core';
import { StackNavigationEventMap, StackNavigationOptions } from '@react-navigation/stack';

import { WordPairingIndex, WordPairingNew, WordPairingShow } from './screens/index';
import { WordPairingStackParamList } from './types/navigation';

export function registerWordPairingScreens<T extends ParamListBase>(
  stack: TypedNavigator<
    T,
    StackNavigationState<WordPairingStackParamList>,
    StackNavigationOptions,
    StackNavigationEventMap,
    any // eslint-disable-line
  >,
) {
  const Stack = stack as TypedNavigator<
    WordPairingStackParamList,
    StackNavigationState<WordPairingStackParamList>,
    StackNavigationOptions,
    StackNavigationEventMap,
    any // eslint-disable-line
  >;
  return (
    <>
      <Stack.Screen name="WordPairingIndex" component={WordPairingIndex} />
      <Stack.Screen
        name="WordPairingNew"
        component={WordPairingNew}
        options={{ headerBackTestID: 'WordPairingNew_headerBack' }}
      />
      <Stack.Screen name="WordPairingShow" component={WordPairingShow} />
    </>
  );
}
